import type { ProfileAdminPermissionsRecords } from "@profile-service-types/index.ts";
import { PermissionRecordType } from "@profile-service-types/index.ts";
import _ from "lodash";
import type { Ref } from "vue";
import type { LocalState } from "./types.ts";

export const isStateEqual = (afterState: LocalState, beforeState: LocalState) => {
  const afterPermissions = [...afterState.selectedCities, ...afterState.sessionTypes, ...afterState.selectedCountries];
  const beforePermissions = [
    ...beforeState.selectedCities,
    ...beforeState.sessionTypes,
    ...beforeState.selectedCountries,
  ];
  const permissionsEq =
    afterPermissions.length === beforePermissions.length &&
    _.isEqualWith(
      _.sortBy(afterPermissions, ["permission_record_type", "permission_record_id", "permit_all_records"]),
      _.sortBy(beforePermissions, ["permission_record_type", "permission_record_id", "permit_all_records"]),
      (a, b) =>
        a.permission_record_type === b.permission_record_type &&
        a.permission_record_id === b.permission_record_id &&
        a.permit_all_records === b.permit_all_records,
    );
  return (
    permissionsEq &&
    afterState.allLocations === beforeState.allLocations &&
    afterState.allSessionTypes === beforeState.allSessionTypes
  );
};

export const localArrayBackToObject = (argsArray) => {
  return {
    allLocations: argsArray[0],
    allSessionTypes: argsArray[1],
    sessionTypes: argsArray[2],
    selectedCountries: argsArray[3],
    selectedCities: argsArray[4],
  };
};

export const updateOrRefreshOriginalProfileValues = (
  profileAdminPermissions: ProfileAdminPermissionsRecords[] | undefined,
  originalCitiesRef: Ref<number[]>,
  originalCountriesRef: Ref<{ [id: string]: ProfileAdminPermissionsRecords }>,
  localState: LocalState,
  sessionTypesOptions: { id: number; name: string }[],
) => {
  if (profileAdminPermissions) {
    const sessionPermissions = {};
    let cityAll = false;
    let countryAll = false;
    let sessionAll = false;
    originalCitiesRef.value = [];
    originalCountriesRef.value = {};
    localState.allLocations = false;
    localState.allSessionTypes = false;
    for (const permission of profileAdminPermissions) {
      if (permission.permission_record_type === PermissionRecordType.City) {
        originalCitiesRef.value.push(Number(permission.permission_record_id));
        if (permission.permit_all_records) {
          cityAll = true;
        }
      } else if (permission.permission_record_type === PermissionRecordType.Country) {
        if (permission.permission_record_id) {
          originalCountriesRef.value[permission.permission_record_id] = permission;
        }
        if (permission.permit_all_records) {
          countryAll = true;
        }
      } else if (permission.permission_record_type === PermissionRecordType.SessionType) {
        if (permission.permission_record_id) {
          sessionPermissions[permission.permission_record_id] = permission;
        }
        if (permission.permit_all_records) {
          sessionAll = true;
        }
      }
    }

    if (cityAll || countryAll) {
      localState.allLocations = true;
      originalCitiesRef.value = [];
      originalCountriesRef.value = {};
      localState.selectedCities = [];
      localState.selectedCountries = [];
    }

    if (sessionAll) {
      localState.allSessionTypes = true;
      localState.sessionTypes = [];
    } else {
      localState.sessionTypes = sessionTypesOptions.filter((value) => !!sessionPermissions[value.id]);
    }
  }
};
